import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const NoCompanyWrapper = styled.section`
  text-align: center;
  min-width: 300px;
  > p {
    padding-top: 48px;
    max-width: 250px;
    margin: 0 auto 32px;
  }
  > ul {
    list-style-type: none;
    list-style-position: inside;
    margin: 0;
    padding: 0;
  }
`;

export const SearchAndAddHoldingWrapper = styled.div`
  vertical-align: top;
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
  ${media.mdUp`
    margin-top: -4px;
    margin-bottom: 20px;
  `}
  ${media.lgUp`
    margin-bottom: ${({ theme }) => theme.x3spacePx}px;
  `}
`;

export const SearchFieldWrapper = styled.div`
  position: relative;

  z-index: 1;

  ${media.smDown`
    margin-bottom: ${({ theme }) => theme.x1spacePx}px;
  `}

  ${media.mdUp`
    min-width: 280px;
    display: inline-block;
    margin-right: ${({ theme }) => theme.x1spacePx}px;
  `}
  ${media.lgUp`
    min-width: 240px;
    padding-left: 28px;
    display: inline-block;
    margin-right: ${({ theme }) => theme.x1spacePx}px;
  `}
`;

export const ResultWrapper = styled('div')`
  cursor: pointer;
`;
